import { createFileRoute } from "@tanstack/react-router";
import { StaffDetailPage } from "@/features/team/staff-detail-page";

export const Route = createFileRoute("/_authenticated/team/$staffId")({
  head: () => ({ meta: [{ title: "Staff member · Rogue Admin" }] }),
  component: StaffDetailPage,
});
